import { IconPropsBase } from './IconPropsBase';

export default function ScreenshotIcon({ size = 20, color = 'currentColor' }: IconPropsBase) {
  if (size > 20) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 -960 960 960">
        <path
          fill={color}
          d="M484.62-277.69v-47.69h100v-100h47.69v147.69H484.62ZM327.69-534.62v-147.69h147.69v47.69h-100v100h-47.69ZM292.31-60Q262-60 241-81q-21-21-21-51.31v-695.38Q220-858 241-879q21-21 51.31-21h375.38Q698-900 719-879q21 21 21 51.31v695.38Q740-102 719-81q-21 21-51.31 21H292.31ZM280-170v37.69q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h375.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-170H280Zm0-60h400v-500H280v500Zm0-560h400v-37.69q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H292.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46V-790Zm0 0v-50 50Zm0 620v50-50Z"
        />
      </svg>
    );
  } else {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} viewBox="0 -960 960 960">
        <path
          fill={color}
          d="M508.62-285.69v-35.69h96v-96h35.69v131.69H508.62ZM319.69-542.62v-131.69h131.69v35.69h-96v96h-35.69ZM276.31-68q-27.01 0-45.66-18.65Q212-105.3 212-132.31v-695.38q0-27.01 18.65-45.66Q249.3-892 276.31-892h407.38q27.01 0 45.66 18.65Q748-854.7 748-827.69v695.38q0 27.01-18.65 45.66Q710.7-68 683.69-68H276.31ZM264-178v45.69q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h407.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-178H264Zm0-52h432v-500H264v500Zm0-552h432v-45.69q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H276.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46V-782Zm0 0v-58 58Zm0 604v58-58Z"
        />
      </svg>
    );
  }
}
